import apiClient from '../core';

export interface GettingStartedProgress {
  openedSite: boolean;
  editedPage: boolean;
  dismissed: boolean;
}

export interface GettingStartedProgressPatch {
  openedSite?: true;
  editedPage?: true;
  dismissed?: true;
}

export const gettingStartedApi = {
  async get(): Promise<GettingStartedProgress> {
    const response = await apiClient.get<{ success: boolean; data: GettingStartedProgress }>(
      '/users/me/getting-started'
    );
    return response.data.data;
  },

  async patch(patch: GettingStartedProgressPatch): Promise<GettingStartedProgress> {
    const response = await apiClient.patch<{ success: boolean; data: GettingStartedProgress }>(
      '/users/me/getting-started',
      patch
    );
    return response.data.data;
  },
};
